export enum BulkActivationStatus {
  Pending = 0,
  Downloaded = 2,
  Printed = 3,
  NewAccount = 4,
  LinkedToAccount = 5
}

export enum ActivationBulkOption {
  PricingPlan = "PricingPlan",
  Quantity = "Quantity"
}

export enum BulkType {
  Generic = "Generic",
  Activation = "Activation"
}

export enum RelationshipBulkType {
  Parent = "Parent",
  Child = "Child"
}

export enum BulkDeliverySourceType {
  All = "All", // super admin, client property
  Digital = "Digital",
  Physical = "Physical"
}
